import React, { useContext } from 'react';
import styles from './SFNavPanel.module.scss';
import { SFDrawer, SFIconButton } from 'sfui';
import SFNavContent from './SFNavContent/SFNavContent';
import { SFNavLink } from './SFNavLink';
import { saveSFNavPanelCollapsedState } from '../../Services/AppService';
import { NavPanelContext } from '../../Context/NavPanelContext';
import { ReminderProps } from 'ui-smartforce-settings';

export interface SFNavPanelProps {
  className?: string;
  links: SFNavLink[];
  bottomLinks: SFNavLink[];
  isBigScreen: boolean;
  isOpen: boolean;
  reminderProps: ReminderProps;
  onClose?: () => void;
}

const SFNavPanel = ({
  className,
  links,
  bottomLinks,
  isBigScreen,
  isOpen,
  reminderProps,
  onClose
}: SFNavPanelProps): React.ReactElement<SFNavPanelProps> => {
  const { isCollapsed, setIsCollapsed } = useContext(NavPanelContext);

  const onDrawerClose = () => {
    onClose && onClose();
  };

  const onToggleCollapse = () => {
    setIsCollapsed((c) => !c);
    saveSFNavPanelCollapsedState(!isCollapsed);
  };

  return (
    <div className={`${styles.sfNavPanel} ${className || ''}`}>
      {isBigScreen && (
        <div className={styles.content}>
          <SFNavContent
            links={links}
            bottomLinks={bottomLinks}
            isPanel={false}
            isCollapsed={isCollapsed}
            reminderProps={reminderProps}
            onToggleCollapse={onToggleCollapse}
          />
        </div>
      )}

      {!isBigScreen && (
        <div className={styles.panelWrapper}>
          <SFDrawer
            className={styles.navPanelDrawer}
            open={isOpen}
            PaperProps={{
              className: styles.navPanelDrawerPaper
            }}
            onClose={onDrawerClose}
          >
            <div className={styles.topBar}>
              <div className={styles.buttons}>
                <SFIconButton
                  sfIcon="Close"
                  sfSize="medium"
                  onClick={onDrawerClose}
                />
              </div>
            </div>

            <SFNavContent
              links={links}
              bottomLinks={bottomLinks}
              isPanel={true}
              reminderProps={reminderProps}
              onDrawerClose={onDrawerClose}
            />
          </SFDrawer>
        </div>
      )}
    </div>
  );
};

export default SFNavPanel;
